import styled from 'styled-components';
import { Dropdown, Text } from '@devfolioco/genesis';

export const Nav = styled.div`
  background-color: ${props => (props.transparent ? 'transparent' : props.theme.color.white[0])};
  box-shadow: ${props => (props.transparent ? 'none' : props.theme.shadow[2])};
  display: flex;
  justify-content: center;
  width: 100%;
  margin-bottom: 4px;
`;

export const Container = styled.div`
  align-items: center;
  display: flex;
  height: 112px;
  justify-content: ${props => (props.hideLogo ? 'flex-end' : 'space-between')};
  max-width: 1200px;
  padding: 0 24px;
  position: relative;
  width: 100%;
`;

export const AvatarContainer = styled.button`
  align-items: center;
  background: none;
  border: 2px solid transparent;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  margin-left: 8px;
  outline: none;
  padding: 0;
  border-radius: 50%;

  &:hover {
    cursor: ${props => (props.disabled ? 'default' : 'pointer')};
  }

  ${props =>
    !props.disabled &&
    `
      &:focus, &:hover {
        border: 2px solid ${props.theme.color.blue[3]};
      }`};
`;

export const AvatarMenu = styled.button`
  border: none;
  background: none;
  outline: none;
  padding: 0;
  cursor: ${props => (props.disabled ? 'default' : 'pointer')};
  align-items: center;
  display: flex;
  position: relative;

  > span {
    margin-right: 12px;
  }

  > div:first-of-type {
    box-sizing: content-box;
    border: 2px solid transparent;
  }

  &:hover,
  &:focus {
    > span {
      color: ${props => props.theme.color.blue[4]};
    }

    > div:first-of-type {
      border: 2px solid ${props => props.theme.color.blue[1]};
    }
  }
`;

export const StyledDropdown = styled(Dropdown)`
  position: absolute;
  right: 16px;
  top: calc(100% - 18px);
  z-index: 10000;
`;

export const Tag = styled(Text)`
  font-size: 9px;
  background-color: ${props => (props.isOpen ? props.theme.color.blue[4] : props.theme.color.grey[4])};
  color: ${props => (props.isOpen ? props.theme.color.white[0] : props.theme.color.grey[7])} !important;
  border: ${props => (props.isOpen ? `${props.theme.color.white[0]} 1px solid` : 'none')};
  padding: 2px 12px;
  letter-spacing: 0.8px;
  margin-right: 8px;
  border-radius: 2px;
`;

export const Separator = styled.div`
  box-sizing: border-box;
  height: 41.5px;
  width: 1px;
  border: 1px solid #273339;
  margin-right: 10px;
`;
